import { Icon16Pencil } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const PencilLineIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M9 20.2499H4.5C4.30109 20.2499 4.11032 20.1709 3.96967 20.0302C3.82902 19.8896 3.75 19.6988 3.75 19.4999V15.3102C3.75009 15.1115 3.82899 14.921 3.96938 14.7805L15.5306 3.21925C15.6713 3.07871 15.862 2.99976 16.0608 2.99976C16.2596 2.99976 16.4503 3.07871 16.5909 3.21925L20.7806 7.40613C20.9212 7.54676 21.0001 7.73746 21.0001 7.93628C21.0001 8.13511 20.9212 8.3258 20.7806 8.46644L9 20.2499Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20.25 20.25H9" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.75 6L18 11.25"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PencilLineIcon = fplIcon(PencilLineIconLocal, Icon16Pencil);
